import React from 'react';
import { FaArrowRight } from 'react-icons/fa'; // Importing the arrow icon

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto p-8 bg-white text-black">
      <h1 className="text-4xl font-bold text-orange-500 text-center mb-6">Terms and Conditions</h1>
      <p className="text-lg mb-4"><FaArrowRight className="inline mr-2 text-orange-500" />Last Updated: 07/06/2024</p>
      <p className="text-lg mb-4">
        <FaArrowRight className="inline mr-2 text-orange-500" />
        By accessing or using our website and services, you agree to comply with and be bound by these Terms and Conditions. 
        Please read these Terms carefully before using our services.
      </p>
      <p className="text-lg mb-4">
        <FaArrowRight className="inline mr-2 text-orange-500" />
        By accessing our site and using our services, you agree to these Terms and our Privacy Policy. If you do not agree to 
        these Terms, you must not use our site or services.
      </p>
      <p className="text-lg mb-4">
        <FaArrowRight className="inline mr-2 text-orange-500" />
        You must be at least 18 years old to use our services. By using our site, you represent and warrant that you have the 
        right, authority, and capacity to enter into these Terms and to abide by all the terms and conditions herein.
      </p>
      <p className="text-lg mb-4">
        <FaArrowRight className="inline mr-2 text-orange-500" />
        Ligovis Technical Solutions Pvt. Ltd. offers cybersecurity courses and related services. We reserve the right to modify 
        our services at any time without prior notice. We are not liable for any modification of the services.
      </p>
      <p className="text-lg mb-4">
        <FaArrowRight className="inline mr-2 text-orange-500" />
        To access certain features of our services, you may need to create an account. You agree to provide accurate and complete 
        information during the registration process and to keep your account information updated. You are responsible for maintaining 
        the confidentiality of your account login information and for all activities that occur under your account.
      </p>
      <p className="text-lg mb-4">
        <FaArrowRight className="inline mr-2 text-orange-500" />
        By enrolling in our courses, you agree to pay the applicable fees. Enrollment in a course is subject to our acceptance and 
        confirmation. Only users who have purchased the courses will have access to them.
      </p>
      <p className="text-lg mb-4">
        <FaArrowRight className="inline mr-2 text-orange-500" />
        All payments must be made through the methods specified on our site. We use third-party payment processors, and you agree 
        to comply with their terms and conditions.
      </p>
      <p className="text-lg mb-4">
        <FaArrowRight className="inline mr-2 text-orange-500" />
        We offer a refund policy as outlined on our site. Please refer to our refund policy for detailed information.
      </p>
      <p className="text-lg mb-4">
        <FaArrowRight className="inline mr-2 text-orange-500" />
        All content on our site, including but not limited to text, graphics, logos, images, and software, is the property of Ligovis 
        Technical Solutions Pvt. Ltd. or its content suppliers and is protected by copyright and other intellectual property laws. 
        You may not use any content from our site without our prior written consent.
      </p>
      <p className="text-lg mb-4">
        <FaArrowRight className="inline mr-2 text-orange-500" />
        You agree not to use our services for any unlawful purpose or in any way that could harm our company or any third party. 
        Prohibited activities include, but are not limited to:
      </p>
      <ul className="list-disc list-inside text-lg mb-4">
        <li>Violating any local, state, national, or international law.</li>
        <li>Infringing on the rights of others, including intellectual property rights.</li>
        <li>Distributing harmful or malicious software.</li>
        <li>Engaging in any activity that disrupts or interferes with our services.</li>
      </ul>
      <p className="text-lg mb-4">
        <FaArrowRight className="inline mr-2 text-orange-500" />
        Our services are provided "as is" and "as available" without any warranties of any kind, either express or implied. 
        We do not warrant that our services will be uninterrupted or error-free, and we disclaim all warranties, including but 
        not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement.
      </p>
      <p className="text-lg mb-4">
        <FaArrowRight className="inline mr-2 text-orange-500" />
        To the maximum extent permitted by law, Ligovis Technical Solutions Pvt. Ltd. shall not be liable for any indirect, incidental, 
        special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or 
        any loss of data, use, goodwill, or other intangible losses, resulting from (a) your use or inability to use our services; 
        (b) any unauthorized access to or use of our servers and/or any personal information stored therein; (c) any interruption or 
        cessation of transmission to or from our services; (d) any bugs, viruses, trojan horses, or the like that may be transmitted 
        to or through our services by any third party; (e) any errors or omissions in any content or for any loss or damage incurred 
        as a result of your use of any content posted, emailed, transmitted, or otherwise made available through the services; and/or 
        (f) the defamatory, offensive, or illegal conduct of any third party.
      </p>
      <p className="text-lg mb-4">
        <FaArrowRight className="inline mr-2 text-orange-500" />
        You agree to indemnify, defend, and hold harmless Ligovis Technical Solutions Pvt. Ltd., its officers, directors, employees, 
        and agents from and against any and all claims, liabilities, damages, losses, or expenses, including reasonable attorneys' fees 
        and costs, arising out of or in any way connected with your access to or use of our services, your violation of these Terms, 
        or your infringement of any intellectual property or other right of any third party.
      </p>
      <p className="text-lg mb-4">
        <FaArrowRight className="inline mr-2 text-orange-500" />
        These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law principles. Any legal action or proceeding arising under these Terms will be brought exclusively in the courts located in India, and the parties hereby irrevocably consent to the personal jurisdiction and venue therein.
</p>
<p className="text-lg mb-4">
<FaArrowRight className="inline mr-2 text-orange-500" />
We reserve the right to modify these Terms at any time. We will notify you of any changes by posting the new Terms on our site.
You are advised to review these Terms periodically for any changes. Your continued use of our services after the posting of any
changes constitutes your acceptance of the new Terms.
</p>
<p className="text-lg mb-4">If you have any questions about these Terms, please contact us at:</p>
<p className="text-lg mb-4">
Ligovis Technical Solutions Pvt. Ltd.<br />
Hyderabad<br />
<a href="mailto:learn@ligovis.com" className="text-orange-500">learn@ligovis.com</a><br />
+917671091557
</p>
</div>
);
};

export default TermsAndConditions;